// Tipos de perfil do backend (TipoPerfilEnum). O /users/by-id devolve o tipoPerfil pelo nome da constante
// ("manager", "coordinator"...), e não pelo número: comparar com 1, 3, 4... nunca batia. Aqui valem os dois.
export const TIPO_PERFIL = {
    GESTOR: { codigo: "manager", valor: 1 },
    MEMBROS: { codigo: "members", valor: 2 },
    COORDENADOR: { codigo: "coordinator", valor: 3 },
    ADMINISTRADOR: { codigo: "administrator", valor: 4 },
    OPERACAO: { codigo: "operator", valor: 5 },
    SUPORTE: { codigo: "support", valor: 6 },
    SUPERVISOR: { codigo: "supervisor", valor: 7 },
    BACKOFFICE: { codigo: "backoffice", valor: 8 },
};

// Só para perfis sem "Tipo de Perfil" cadastrado: deduz o tipo pelo nome, como as telas faziam antes
const TIPO_PELO_NOME = [
    ["admin", TIPO_PERFIL.ADMINISTRADOR],
    ["suporte", TIPO_PERFIL.SUPORTE],
    ["gestor", TIPO_PERFIL.GESTOR],
    ["coord", TIPO_PERFIL.COORDENADOR],
    ["supervis", TIPO_PERFIL.SUPERVISOR],
    ["backoffice", TIPO_PERFIL.BACKOFFICE],
    ["opera", TIPO_PERFIL.OPERACAO],
];

const tipoDoPerfil = (perfil) => {
    if (perfil === null || perfil === undefined) return null;
    const bruto = typeof perfil === "object" ? (perfil.tipoPerfil?.code ?? perfil.tipoPerfil) : null;
    if (bruto !== null && bruto !== undefined && bruto !== "") {
        return Object.values(TIPO_PERFIL).find(t => String(bruto).toLowerCase() === t.codigo || Number(bruto) === t.valor) || null;
    }
    const nome = (typeof perfil === "string" ? perfil : (perfil.nome || perfil.ccNome || "")).toLowerCase();
    const encontrado = TIPO_PELO_NOME.find(([trecho]) => nome.includes(trecho));
    return encontrado ? encontrado[1] : null;
};

/** O usuário tem algum perfil de um destes tipos? Ex.: temTipoPerfil(userPerfils, TIPO_PERFIL.GESTOR, TIPO_PERFIL.SUPORTE) */
export function temTipoPerfil(userPerfils, ...tipos) {
    if (!Array.isArray(userPerfils)) return false;
    return userPerfils.some(perfil => tipos.includes(tipoDoPerfil(perfil)));
}

// Permissão de atender a Fila de Solicitações (Perfis > Fila de Solicitações > Editar)
export const PERMISSAO_FILA_SOLICITACOES = "c067_U";

/**
 * Devolver, reativar e migrar ficha/contrato direto, sem passar pela Fila de Solicitações (mesma regra do backend,
 * PermissaoDevolucaoService): Administrador, Suporte e Gestor; Coordenador e Supervisor só com a permissão da fila.
 * Os demais perfis enviam a solicitação para a fila do suporte.
 */
export function podeDevolverOuMigrarDireto(userPerfils, userFunctionalities) {
    if (temTipoPerfil(userPerfils, TIPO_PERFIL.ADMINISTRADOR, TIPO_PERFIL.SUPORTE, TIPO_PERFIL.GESTOR)) return true;
    return temTipoPerfil(userPerfils, TIPO_PERFIL.COORDENADOR, TIPO_PERFIL.SUPERVISOR)
        && Array.isArray(userFunctionalities) && userFunctionalities.includes(PERMISSAO_FILA_SOLICITACOES);
}
